import { useEffect, useState } from 'react'
import { fxCustomersApi, fxSalesApi } from '../../services/api'
import LocationsMaps from '../../components/LocationsMaps'

export default function FxLocationsPage() {
  const [customers, setCustomers] = useState<any[]>([])
  const [sales, setSales] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [customersRes, salesRes] = await Promise.all([
          fxCustomersApi.list(),
          fxSalesApi.list(),
        ])
        setCustomers(customersRes.data.customers || [])
        setSales(salesRes.data.sales || [])
      } catch (error) {
        console.error('Error fetching FX locations data:', error)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  if (loading) {
    return <div className="text-center py-8">Cargando...</div>
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-espresso-800">Ubicaciones — FX Admin</h1>
      </div>

      <LocationsMaps customers={customers} sales={sales} />
    </div>
  )
}
